export default __webpack_public_path__ + "static/media/vray-logo.640b626c.svg";